import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const indicatorVariants = cva('size-1.5 inline-flex rounded-full', {
  variants: {
    variant: {
      default: 'bg-gray-300',
      destructive: 'bg-red-500',
      success: 'bg-green-500',
      neutral: 'bg-gray-950',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export interface IndicatorProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof indicatorVariants> {}

export const Indicator = ({ variant, className }: IndicatorProps) => {
  return <div className={cn(indicatorVariants({ variant, className }))} />
}
